import { render, staticRenderFns } from "./firstIndex.vue?vue&type=template&id=49442180&scoped=true&"
import script from "./firstIndex.vue?vue&type=script&lang=js&"
export * from "./firstIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49442180",
  null
  
)

export default component.exports